import CONFIG from '../config/app-config';

class ApiManager {
  static buildUrl(path) {
    if (path.startsWith('http')) return path;
    return `${CONFIG.BASE_URL}${path}`;
  }

  static async request(path, options = {}) {
    const url = ApiManager.buildUrl(path);
    const response = await fetch(url, options);
    if (!response.ok) {
      const errorText = await response.text();
      let errorMessage = `HTTP error! status: ${response.status}`;
      try {
        const errorJson = JSON.parse(errorText);
        errorMessage = errorJson.message || errorMessage;
      } catch (_) {}
      throw new Error(errorMessage);
    }

    const data = await response.json();
    if (data && data.error) {
      throw new Error(data.message);
    }
    return data;
  }
}

export default ApiManager;

